import React, { useEffect, useState } from "react";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { ProfileContent } from "./ProfileContent";
import { Col, Container, Row } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { AppRoles } from "../auth/authConfig";

export const PageLayout = ({ children }: { children: React.ReactNode }) => {
    useMsalAuthentication(InteractionType.Redirect);
    const { instance, accounts } = useMsal();
    const account = useAccount(accounts[0]);
    const [hasAccess, setHasAccess] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        if (account) {
            const roles = (account.idTokenClaims as any).roles ? (account.idTokenClaims as any).roles as string[] : [];
            setHasAccess(roles.some((i: any) => i === AppRoles.Visitors.toString()));
            setIsAdmin(roles.some((i: any) => i === AppRoles.Administrator.toString()))
        }
    }, [account]);

    const content = <>
        <Container fluid className="ap-top-bar ap-green">
            <div className="layout-container">
                <Row>
                    <Col className="d-none d-sm-done d-md-block">
                        <AuthenticatedTemplate>
                            <Container fluid>
                                <Row>
                                    <Col md={4} className="ps-0"><ProfileContent /></Col>
                                    <Col md={6} className="text-end ps-0">
                                        {isAdmin ? <Row className="justify-content-end">
                                            <Col md="auto"><Link to="/">Home</Link></Col>
                                            <Col md="auto"><Link to="/statistics">Statistics</Link></Col>
                                        </Row> : <></>}
                                    </Col>
                                    <Col md={2} className="text-end pe-0"><SignOutButton /></Col>
                                </Row>
                            </Container>
                        </AuthenticatedTemplate>
                        <UnauthenticatedTemplate>
                            <SignInButton />
                        </UnauthenticatedTemplate>
                    </Col>
                </Row>
            </div>
        </Container>
        {children}
    </>;

    return (hasAccess ? content : <><Navigate to="/no-access"></Navigate></>);
};